<template>
    <layout-portal>
        <div class="container">
			<div class="row">
				<div class="col-md-12 text-center mt-3">
					<h1>Oops!</h1>
					<h2>404 Página não encontrada </h2>
					<div class="error-actions">
						<button @click="goHome" type="button" class="btn btn-dark">Home</button>
					</div>
				</div>
			</div>
		</div>
    </layout-portal>
</template>

<script>
    import mixin from '../mixin'

    export default
    {
        mixins: [mixin],
        methods: {
            goHome: function() {
                this.$router.push({name: this.$root.$env.FIRST_COMPONENT.name});
            },
            goDashboard: function() {
                this.$router.push({name: 'portal.dashboard'});
            }
        }
    }
</script>